/* Fiches produits BOUTIQUE : petits ajouts visuels mobile (style cuure.com).
   N'intervient sur aucun comportement existant :
   - lit le variant choisi (champ cache #product-variant-id, rempli par le script d'origine)
     pour mettre a jour le bloc prix / pastilles ajoute ;
   - la barre collante ne fait que cliquer sur le vrai bouton "Commander". */
(function () {
  var root = document.getElementById('product-page-content');
  if (!root) return;

  var data = [];
  try { data = JSON.parse((document.getElementById('pc-variants') || {}).textContent || '[]'); } catch (e) {}

  function find(id) {
    for (var i = 0; i < data.length; i++) if (String(data[i].id) === String(id)) return data[i];
    return null;
  }
  function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function render() {
    var input = document.getElementById('product-variant-id');
    var v = input && find(input.value);
    if (!v) return;
    each('[data-pc-now]', function (el) { el.textContent = v.p; });
    each('[data-pc-was]', function (el) { el.textContent = v.c || ''; el.hidden = !v.c; });
    each('[data-pc-pct]', function (el) { el.textContent = '-' + v.r + '%'; el.hidden = !(v.r > 0); });
    each('[data-pc-sold]', function (el) { el.hidden = !!v.a; });
    root.classList.toggle('pc-is-sold', !v.a);
    /* epuise : on ne peut pas commander (bouton desactive + "Epuise") */
    each('.add-to-cart-btn', function (b) { b.disabled = !v.a; b.setAttribute('aria-disabled', v.a ? 'false' : 'true'); });
    each('[data-gr-cta]', function (el) { el.textContent = v.a ? 'Commander' : 'Épuisé'; });
    var sb = document.querySelector('#pc-sticky .pc-sticky__btn'); if (sb) { sb.disabled = !v.a; }
  }
  render();

  // Mobile : toutes les rubriques "Le produit en detail" fermees a l'ouverture (le clic les ouvre comme avant)
  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
    each('.pd-item', function (it) {
      it.setAttribute('data-state', 'closed');
      var b = it.querySelector('.pd-item__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  root.addEventListener('submit', function (e) { if (root.classList.contains('pc-is-sold')) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  root.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.add-to-cart-btn'); if (b && b.disabled) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);

  // description courte vide (produit sans texte) : on retire juste l'espace vide
  var sd = root.querySelector('.short-desc');
  if (sd && !sd.textContent.trim()) sd.classList.add('pc-empty');

  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.variant-btn')) setTimeout(render, 0);
  });

  // Carrousel "LE BON GESTE" : carte active pleine, suivantes attenuees + pastilles
  var gt = root.querySelector('[data-pc-geste]');
  if (gt) {
    var cards = gt.querySelectorAll('.pc-geste__card');
    var gdots = root.querySelectorAll('.pc-geste__dots span');
    var gtick = false;
    var gset = function () {
      gtick = false;
      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
      var idx = Math.round(gt.scrollLeft / step);
      if (gt.scrollLeft >= gt.scrollWidth - gt.clientWidth - 2) idx = cards.length - 1;
      idx = Math.max(0, Math.min(cards.length - 1, idx));
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('is-active', i === idx);
        if (gdots[i]) gdots[i].classList.toggle('is-active', i === idx);
      }
    };
    gt.addEventListener('scroll', function () { if (!gtick) { gtick = true; requestAnimationFrame(gset); } }, { passive: true });
  }

  var real = root.querySelector('.add-to-cart-btn');
  var bar = document.getElementById('pc-sticky');
  var end = document.getElementById('page-bottom-anchor');
  if (!real || !bar) return;

  bar.querySelector('.pc-sticky__btn').addEventListener('click', function () { if (!real.disabled) real.click(); });

  if (!('IntersectionObserver' in window)) return;
  var pastButton = false, beforeEnd = true;
  function update() { bar.classList.toggle('is-on', pastButton && beforeEnd); }
  new IntersectionObserver(function (entries) {
    var en = entries[0];
    pastButton = !en.isIntersecting && en.boundingClientRect.top < 0;
    update();
  }).observe(real);
  if (end) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      beforeEnd = en.boundingClientRect.top > 0; // cachee une fois le bloc produit depasse
      update();
    }).observe(end);
  }
})();

/* Fiche produit telephone facon cuure : galerie (compteur + vignettes), quantite, stock, onglets */
(function () {
  var root = document.getElementById('product-page-content'); if (!root) return;
  var tr = root.querySelector('[data-pc-gal-track]'), cur = root.querySelector('[data-pc-gal-cur]'), th = [].slice.call(root.querySelectorAll('[data-pc-thumb]'));
  if (tr) {
    var t; tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var i = Math.round(tr.scrollLeft / tr.clientWidth); if (cur) cur.textContent = i + 1; th.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); var a = th[i]; if (a) a.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }, 60); }, { passive: true });
    th.forEach(function (b, k) { b.addEventListener('click', function () { var x = k * tr.clientWidth; tr.scrollTo({ left: x, behavior: 'smooth' }); setTimeout(function () { if (Math.abs(tr.scrollLeft - x) > 2) tr.scrollLeft = x; }, 500); }); });
  }
  var qi = root.querySelector('[data-pc-qty-in]');
  root.querySelectorAll('[data-pc-qty]').forEach(function (b) { b.addEventListener('click', function () { if (!qi) return; var v = Math.max(1, Math.min(99, (parseInt(qi.value, 10) || 1) + (+b.getAttribute('data-pc-qty')))); qi.value = v; }); });
  var stock = root.querySelector('[data-pc-instock]');
  if (stock) new MutationObserver(function () { stock.hidden = root.classList.contains('pc-is-sold'); }).observe(root, { attributes: true, attributeFilter: ['class'] });
  var tabs = [].slice.call(document.querySelectorAll('.pc-tabs a'));
  tabs.forEach(function (a) { a.addEventListener('click', function (e) { var el = document.querySelector(a.getAttribute('href')); if (!el) return; e.preventDefault(); tabs.forEach(function (x) { x.classList.toggle('is-on', x === a); }); window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' }); }); });
})();
